angular.module('app.leftPad.leftPadFilter', [])
  .filter('left_pad', [
    function () {
      'use strict';

      return function (input, length, char) {
        if (typeof input === "undefined") return "";
        let output;
        output = input.toString();
        if (!length || isNaN(parseInt(length))) {
          length = 0;
        }
        if (!char) {
          char = '0';
        }
        while (!(output.length >= length)) {
          output = char + input;
        }
        return output;
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/leftPad/leftPadFilter.js